const PipelineListItem = (props) => {
    return <div> hello</div>
}

export default PipelineListItem;
